<div class="container mt-5">
    <div class="card card-primary">

        <!-- /.card-header -->
        <!-- form start -->
        <div class="row">
            <form id="quickForm" [formGroup]="retailerForm" (ngSubmit)="onSubmit()">
                <div class="card-body">
                    <div class="row">
                        <app-loader *ngIf="loader"></app-loader>
                        <div class="col-6">
                            <div class="form-group">
                                <app-form-field label="{{ 'Discount Template' }}" [required]="true"
                                [control]="retailerForm.controls['discountTemplateId']" [isInline]="false">
                                <app-select [items]="DiscountTemplates"  formControlName="discountTemplateId"></app-select>
                            </app-form-field>
                            </div>
                        </div>
                     </div>

                </div>
                <!-- /.card-body -->
                <div class="card-footer">
                    <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button> &nbsp;&nbsp;
                    <button type="button" class="btn btn-outline-dark"
                    (click)="activeModal.dismiss({ refresh: false })">
                        Close
                    </button>
                </div>
            </form>
        </div>
    </div>


</div>